import { defineAction } from '~/prix'
import { z } from 'zod'
import animalProductionCreateAction from './animalProductionCreate.action.json' with { type: 'json' }
import { animalProductionUpsertInputObject } from '../animalProductionObject'

const animalProductionCreateDefinition = defineAction({
  ...animalProductionCreateAction,
  input: animalProductionUpsertInputObject,
  output: z.object({
    id: z.string().uuid(),
  }),
})

export default animalProductionCreateDefinition
